import { styled, theme } from '@clickcease/cc-client-components-lib'

export const StripeFormStyled = styled('form', {
  '@bp1': {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
})

export const StripeFieldWrapper = styled('div', {
  padding: '$1 $6',
  border: 'solid 1px $lightNeutral',
  borderRadius: '4px',
  marginBottom: '$8',
})

export const StripeCvcDateWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  '> div': {
    width: '42%',
    marginBottom: '0px',

    '@bp1': {
      width: '40%',
    },
  },
})

export const StripeFormCountryAndState = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
})

export const StripeFormError = styled('div', {
  color: '$error',
  textAlign: 'center',
  height: '16px',
  marginTop: '0px',
  marginBottom: '$10',
  fontSize: '$md',
})

export const StripeFormSuccess = styled('div', {
  color: '$success',
  textAlign: 'center',
  height: '16px',
  marginTop: '0px',
  marginBottom: '$10',
})

export const CheckoutCreditCardCancelAnytime = styled('div', {
  fontSize: '$md',
  fontWeight: '$r',
  width: '100%',
})

export const STRIPE_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: theme.fontSizes.md.value,
      padding: theme.space['5'].value,
      fontWeight: theme.fontWeights.l.value,
      color: theme.colors.black.value,
      lineHeight: '30px',
      height: '30px',
      letterSpacing: '0.025em',
      '::placeholder': {
        color: theme.colors.neutral.value,
      },
    },
    invalid: {
      color: theme.colors.error.value,
    },
  },
}

export const ToasterWrapper = styled('div', {
  width: '440px',

  variants: {
    reactivation: {
      true: {
        width: '415px',
      },
      false: {
        width: '440px',
      },
    },
  },

  defaultVariants: {
    reactivation: false,
  },
})
